import {ReducerStatuses} from "services/utils/utils";
import {createSelector} from "@reduxjs/toolkit";

const forgotState = state => state.account.forgot;

export const forgotLoading = createSelector([forgotState], (state) => state.status === ReducerStatuses.LOADING);
export const forgotSuccess = createSelector([forgotState], (state) => state.status === ReducerStatuses.SUCCESS);